import type { CustomAttribute } from '@/types';

import { cn } from '../../utils/cn';

import { ButtonElement } from '../../buttonElement';
import { paginationContainer, paginationLoadMore } from './LoadMore.css';
import type { PaginateAttributes } from './LoadMore.types';

const buttonNode = {
  type: 'button',
  attrs: {
    id: '6c58b364-4065-44b7-88dc-ef3ce3b7f5d6',
    href: null,
    size: 'normal',
    margin: '0px',
    target: null,
    padding: '12px 16px 12px 16px',
    alignment: 'left',
    borderColor: '#E5E7EB',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '8px',
    iconPlacement: 'left',
    customTextColor: '#F9FAFB',
    customBackgroundColor: '#030712',
  },
  content: [
    {
      text: 'Load more',
      type: 'text',
    },
  ],
};

const getOverriddenNode = (attributes: PaginateAttributes, isLive: boolean) => {
  return {
    ...buttonNode,
    attrs: {
      ...buttonNode.attrs,
      text: attributes.paginateButtonText || 'Load more',
      busyText: attributes.paginateButtonBusyText || 'Loading...',
      padding: attributes.paginateButtonPadding,
      borderColor: attributes.paginateButtonBorderColor,
      borderStyle: attributes.paginateButtonBorderStyle,
      borderWidth: attributes.paginateButtonBorderWidth,
      borderRadius: attributes.paginateButtonBorderRadius,
      icon: attributes.paginateButtonIcon,
      alignment: attributes.paginateButtonIconPlacement,
      iconPlacement: attributes.paginateButtonIconPlacement,
      iconColor: attributes.paginateButtonIconColor,
      customTextColor: attributes.paginateButtonTextColor,
      customBackgroundColor: attributes.paginateButtonBackgroundColor,
      hoverCustomBackgroundColor: attributes.paginateButtonHoverBackgroundColor,
      hoverCustomTextColor: attributes.paginateButtonHoverTextColor,
      shadow: attributes.paginateButtonShadow,
      fontFamily: attributes.paginateButtonFontFamily,
      fontSize: attributes.paginateButtonFontSize,
      fontWeight: attributes.paginateButtonFontWeight,
      customAttributes: {
        className: isLive ? 'cursor-pointer' : undefined,
      },
    },
  };
};

interface LoadMoreProps {
  onClick: () => void;
  attributes: PaginateAttributes;
  isBusy: boolean;
  isLive: boolean;
  customAttributes?: CustomAttribute;
}

export const LoadMore = ({ onClick, attributes, isBusy, isLive = false, customAttributes }: LoadMoreProps) => {
  const overriddenNode = getOverriddenNode(attributes, isLive);
  const { className: customAttributesClassName, ...restAttributes } = customAttributes || {};

  return (
    <div
      className={cn('flex justify-center w-full items-center', paginationContainer, customAttributesClassName)}
      {...restAttributes}
    >
      <ButtonElement
        onClick={onClick}
        element={{
          type: 'button',
          attrs: overriddenNode.attrs,
          content: [],
        }}
        disabled={isBusy}
      >
        <span className={cn(paginationLoadMore)}>
          {isBusy ? overriddenNode.attrs.busyText : overriddenNode.attrs.text}
        </span>
      </ButtonElement>
    </div>
  );
};
